import { useEffect, useState } from 'react'

import './_subsOptions.scss'
import { useTranslation } from 'react-i18next'
import { useQuery, useQueryClient } from 'react-query'

import { IconDollarCircleArrows } from 'assets/svg/sprite'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import LayoutHeader from 'features/LayoutHeader/LayoutHeader'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'
import { getSubscriptionPlans } from 'services/endpoints/settings/general/subscription'
import { useUserProfile } from 'store'

export const SubscriptionOptions = () => {
    const queryClient = useQueryClient()
    const [price, setPrice] = useState('loading...')
    const userData = useUserProfile()!
    const { t } = useTranslation()

    useEffect(() => {
        if (queryClient.getQueryData('loggedUserSubPlans')) {
            const pricePlans: any =
                queryClient.getQueryData('loggedUserSubPlans')
            const price = pricePlans.subscriptions.filter(
                (plan: any) => plan.month_count === 1 && plan.active === 1
            )[0].price
            setPrice(price === 0 ? 'Free' : price)
        }
    }, [])

    useQuery(
        'loggedUserSubPlans',
        async () => await getSubscriptionPlans(userData.id),
        {
            onSuccess: resp => {
                const monthlyPlan = resp.subscriptions.filter(
                    (plan: any) => plan.month_count === 1 && plan.active === 1
                )[0]
                setPrice(monthlyPlan.price === 0 ? 'Free' : monthlyPlan.price)
            }
        }
    )

    return (
        <WithHeaderSection
            headerSection={
                <LayoutHeader
                    type='basic'
                    section={t('general')}
                    title={t('subscriptionPricing')}
                />
            }
        >
            <ActionCard
                icon={<IconDollarCircleArrows />}
                hasArrow
                absFix
                text={t('setPrice')}
                description={
                    userData?.default_subscription_price === null ||
                    userData?.default_subscription_price === undefined
                        ? t('priceNotSet')
                        : Number(userData.default_subscription_price) === 0
                            ? t('Free')
                            : `$${userData.default_subscription_price}`
                }
                link='/settings/general/subscription-options/set-price'
            />
            <ActionCard
                icon={<IconDollarCircleArrows />}
                hasArrow
                absFix
                text={t('discountedBundles')}
                description={t('membersCanSaveTxt')}
                link='/settings/general/subscription-options/discounted-bundles'
            />
            <ActionCard
                icon={<IconDollarCircleArrows />}
                hasArrow
                absFix
                text={t('promoCampaigns')}
                description={t('offerAFreeTrialTxt')}
                link='/settings/general/subscription-options/promo-campaigns'
            />
            <ActionCard
                icon={<IconDollarCircleArrows />}
                hasArrow
                absFix
                text={t('createFreeTrialLink')}
                description={t('createAndManage')}
                link='/settings/general/subscription-options/free-trial-link'
            />
        </WithHeaderSection>
    )
}
